import api from "./axios";

export const getCustomers = (params = {}) => api.get("/customers", { params });

export const searchCustomers = (query, limit = 20) =>
  api.get("/customers/search", { params: { query, limit } });

export const getCustomer = (customerPublicId) =>
  api.get(`/customers/${customerPublicId}`);

export const getCustomerTimeline = (customerPublicId) =>
  api.get(`/customers/${customerPublicId}/timeline`);

export const createCustomer = (data, idempotencyKey) =>
  api.post("/customers", data, {
    headers: { "Idempotency-Key": idempotencyKey },
  });

export const updateCustomer = (customerPublicId, data) =>
  api.patch(`/customers/${customerPublicId}`, data);
